import { CACHE_TIMES } from './cache';

export const CSV_CONFIG = {
  MIME_TYPE: 'text/csv;charset=utf-8;',
  LINE_SEPARATOR: '\n',
  QUERY_OPTIONS: {
    refetchOnMount: false,
    staleTime: CACHE_TIMES.SHORT,
  },
};
